import angular from 'angular';

import _2018SATPilot from './2018-sat-pilot/2018-sat-pilot';

const integrations = angular.module('integrations', [_2018SATPilot]);

export default integrations.name;
